import { SHOW_PRESENT_MAP } from './types';

export const showPresentMap = presentMapEnabled => ({
  type: SHOW_PRESENT_MAP,
  presentMapEnabled,
});
